module.exports = {"211121001":"荣滨街道","211121002":"二界沟街道","211121100":"大洼镇","211121101":"田庄台镇","211121103":"东风镇","211121104":"新开镇","211121105":"田家镇","211121106":"清水镇","211121107":"新兴镇","211121108":"西安镇","211121109":"新立镇","211121110":"荣兴镇","211121111":"王家镇","211121112":"唐家镇","211121113":"平安镇","211121114":"赵圈河镇","211121115":"榆树镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211121.json
// module id = 669
// module chunks = 0